import { useNavigate } from "react-router-dom";
import { Pencil } from "lucide-react";
import { useAuth } from "../context/AuthContext";

/**
 * Inline pencil icon — deep-links admins to
 * `/admin/booking-overrides?edit=<property_key>` for the specific
 * override card they're viewing.  Renders as `null` for non-admins
 * so travelers never see it.
 *
 * Uses `stopPropagation` on click so it doesn't bubble into the
 * surrounding card's tap-to-open-modal handler.
 */
export default function AdminEditOverridePencil({ propertyKey, testId, tone = "light" }) {
  const nav = useNavigate();
  const { user } = useAuth();
  if (!user || user.role !== "admin") return null;
  if (!propertyKey) return null;
  const bg = tone === "dark"
    ? "bg-white/85 hover:bg-white text-tb-navy"
    : "bg-tb-navy/85 hover:bg-tb-navy text-white";
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        nav("/admin/booking-overrides?edit=" + encodeURIComponent(propertyKey));
      }}
      data-testid={testId}
      title="Edit override"
      aria-label="Edit override"
      className={`w-7 h-7 rounded-full grid place-items-center shadow-lg ${bg}`}
    >
      <Pencil className="w-3.5 h-3.5" />
    </button>
  );
}
